// removed by extract-text-webpack-plugin
module.exports = {"modal":"_1rZCn-OdVL8DS86eCaUA9x","active":"_15yR7e_LImBL3Fc3wu9O5K","modal--sm":"_3pnjgxdm813JOlsJcJM_dh","modal__dialog":"_3Ldm6liXFlwfcRwNK4pAx-","modal__content":"_3Jkltfj6f1kkesDYYacaoI","modal__header":"_2u9nwo_SSamNrg2SdbR7om","title":"_3NI6ipdAH-_OnIZ5qT9Jxs","close":"_1K_WYtAFmWSeGTaGYaikFB","icon":"BkD5_4YEc4jY2NaBR8tgx","modal__body":"G3j5TTgwLYMz0hJ0keTi-","text-devided":"_1wgJgzemJ5WqX8cvpsQdfo","input--icon":"_5f6nUZN0T6VzZzAUdW2jr","input":"Tm_cGEqPx6hu9qptN5BMS","modal__figure":"nkJaXoDsIu_HtGKJdK-JY","modal__errormessage__spacing":"_2QdDx20ZPxNwvfzKxB1O8M"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AuthModal/auth-modal.scss
// module id = 1193
// module chunks = 0